module.exports = __webpack_public_path__ + "mo/img/notice-ceo-signature.7889e791.png";